var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDescriptionList",
    {
      staticClass: "object-block__description-list",
      attrs: { variant: "frozen-field" }
    },
    [
      _vm.showCompany && _vm.data.company
        ? _c(
            "CompassDescriptionListItem",
            { attrs: { label: _vm.$t.__("email.EmailRelatedObject.company") } },
            [
              _c("CompassLink", {
                attrs: {
                  label: _vm.data.company.name,
                  link: _vm.data.company.link,
                  target: "_blank"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showContact && _vm.data.contact
        ? _c(
            "CompassDescriptionListItem",
            { attrs: { label: _vm.$t.__("common.labels.contact") } },
            [
              _c("CompassLink", {
                attrs: {
                  label: _vm.data.contact.fullName,
                  link: _vm.data.contact.link,
                  target: "_blank"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showEmail && _vm.data.email
        ? _c(
            "CompassDescriptionListItem",
            { attrs: { label: _vm.$t.__("common.labels.email") } },
            [
              _c("ContactDetails", {
                attrs: { value: _vm.data.email, variant: "email" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showPhone && _vm.data.phone_number
        ? _c(
            "CompassDescriptionListItem",
            { attrs: { label: _vm.$t.__("common.labels.phone") } },
            [
              _c("ContactDetails", {
                attrs: { value: _vm.data.phone_number, variant: "phone" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showMobile && _vm.data.mobile_number
        ? _c(
            "CompassDescriptionListItem",
            { attrs: { label: _vm.$t.__("common.labels.mobile") } },
            [
              _c("ContactDetails", {
                attrs: { value: _vm.data.mobile_number, variant: "phone" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showAddress && _vm.data.address
        ? _c(
            "CompassDescriptionListItem",
            { attrs: { label: _vm.$t.__("common.labels.address") } },
            [
              _vm._v("\n        " + _vm._s(_vm.data.address.street)),
              _c("br"),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.data.address.postal_code) +
                  " " +
                  _vm._s(_vm.data.address.city) +
                  "\n    "
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }